import { Divider } from "@mui/material";
import {
  Claim,
  ServiceClaim,
  ServiceSummary,
  ServiceWithClaims,
} from "data/interfaces";
import { ClaimOptionSelection } from "./ClaimOptionSelection";
import { ClaimTypeSelection } from "./ClaimTypeSelection";

interface ClaimsSelectionContentProps {
  services: ServiceSummary[];
  selected: ServiceWithClaims[];
  updateSelected: (selectedServicesWithClaims: ServiceWithClaims[]) => void;
  defaultSelected: ServiceWithClaims[];
  selectedUsersCount: number;
}

export function ClaimsSelectionContent({
  services,
  selected,
  updateSelected,
  defaultSelected,
  selectedUsersCount,
}: ClaimsSelectionContentProps) {
  let servicesWithClaimOptions = services
    .filter((s) => s.serviceClaims.find((sc) => sc.options.length >= 1))
    .sort((a, b) => (a.name > b.name ? 1 : -1));
  let servicesWithClaimTypes = services
    .filter((s) => s.serviceClaims.find((sc) => sc.options.length === 0))
    .sort((a, b) => (a.name > b.name ? 1 : -1));

  const handleClaimSelect = (
    checked: boolean,
    service: ServiceSummary,
    claim: ServiceClaim,
    claimValue: string
  ) => {
    const userClaims = selected.find(
      (s) =>
        s.serviceReference === service.serviceReference &&
        s.licenseReference === service.licenseReference
    )?.claims;

    if (userClaims) {
      const index = userClaims.findIndex((s) => s.type === claim.claimType);

      let newClaims = [...userClaims];
      if (checked) {
        if (index >= 0) {
          newClaims = newClaims.map((c) =>
            c.type === claim.claimType
              ? ({
                  type: c.type,
                  value: [...userClaims[index].value, claimValue],
                } as Claim)
              : c
          );
        } else
          newClaims.push({
            type: claim.claimType,
            value: claimValue !== "" ? [claimValue] : [],
          } as Claim);
      } else {
        if (index === -1) return;
        if (index >= 0) {
          if (userClaims[index].value.length > 1) {
            newClaims = newClaims.map((c) =>
              c.type === claim.claimType
                ? ({
                    type: c.type,
                    value: [
                      ...userClaims[index].value.filter(
                        (v) => v !== claimValue
                      ),
                    ],
                  } as Claim)
                : c
            );
          } else {
            newClaims.splice(index, 1);
          }
        }
      }

      updateSelected([
        ...selected.filter(
          (s) => s.licenseReference !== service.licenseReference
        ),
        {
          serviceReference: service.serviceReference,
          licenseReference: service.licenseReference,
          claims: newClaims,
        },
      ]);
    } else {
      updateSelected([
        ...selected,
        {
          serviceReference: service.serviceReference,
          licenseReference: service.licenseReference,
          claims: [
            {
              type: claim.claimType,
              value: claimValue !== "" ? [claimValue] : [],
            } as Claim,
          ],
        },
      ]);
    }
  };

  return (
    <>
      {servicesWithClaimTypes.length > 0 && (
        <ClaimTypeSelection
          services={servicesWithClaimTypes}
          defaultSelected={defaultSelected}
          selectedUsersCount={selectedUsersCount}
          handleClaimSelect={handleClaimSelect}
        />
      )}
      {servicesWithClaimTypes.length > 0 &&
        servicesWithClaimOptions.length > 0 && <Divider />}
      {servicesWithClaimOptions.length > 0 && (
        <ClaimOptionSelection
          services={servicesWithClaimOptions}
          defaultSelected={defaultSelected}
          selectedUsersCount={selectedUsersCount}
          handleClaimSelect={handleClaimSelect}
        />
      )}
    </>
  );
}
